import { action, makeObservable, observable } from 'mobx'
import { getURL, URL_TYPES } from '@voicekey/api/http'
import { CONFIGURATOR_API } from '@voicekey/api/configurator/configurator'

const url = getURL(URL_TYPES.CONFIGURATOR)

export class Files {
  constructor (rootStore) {
    makeObservable(this, {
      _files: observable,
      getFiles: action,
      addFiles: action,
      deleteFiles: action
    })
    this.rootStore = rootStore
  }

  _files = []

  get files () {
    return this._files
  }

  set files (files) {
    this._files = files
  }

  async getFiles () {
    try {
      const response = await CONFIGURATOR_API.getFiles(url, this.rootStore.configuratorStoreSettings.token)
      this.files = response.data.file_names
    } catch (error) {
      this.rootStore.messagesStore.setMessage(error)
    }
  }

  async addFiles (file) {
    try {
      await CONFIGURATOR_API.addFiles(url, this.rootStore.configuratorStoreSettings.token, file)
    } catch (error) {
      this.rootStore.messagesStore.setMessage(error)
    }
  }

  async deleteFiles (name) {
    try {
      await CONFIGURATOR_API.deleteFiles(url, this.rootStore.configuratorStoreSettings.token, name)
    } catch (error) {
      this.rootStore.messagesStore.setMessage(error)
    }
  }
}
